/*
 * @Author: your name
 * @Date: 2021-04-15 11:24:30
 * @LastEditTime: 2021-08-30 09:21:17
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \yijiu_shopmall_h5\src\main.js
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuex from 'vuex'
import http from '../http'
import '../vant'
import '../rem'
import '../src/assets/css/icon.css'
import {
  shareExtensionFg,
  prohibitweixinShare,
  isIphoneX
} from './public/public.js'
import SlideVerify from 'vue-monoplasty-slide-verify'
import Oss from './public/oss'
import VueAMap from 'vue-amap'
import CanvasPoster from 'vue-canvas-poster'
import { Popup } from 'vant'
import TIM from 'tim-js-sdk'
Vue.use(Popup)
Vue.prototype.TIM = TIM
Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  key: 'your amap key',
  plugin: [
    'AMap.Autocomplete',
    'AMap.PlaceSearch',
    'AMap.Scale',
    'AMap.OverView',
    'AMap.ToolBar',
    'AMap.MapType',
    'AMap.PolyEditor',
    'AMap.CircleEditor'
  ],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
})
Vue.use(Oss)
Vue.use(SlideVerify)
Vue.prototype.httpsConfig = window.location.href.split('.cn')[0]
localStorage.setItem('httpsConfig', window.location.href.split('.cn')[0])
// 判断是不是在微信端
var ua = navigator.userAgent.toLowerCase()
if (ua.match(/MicroMessenger/i) == 'micromessenger') {
  Vue.prototype.isWexinLogin = true
} else {
  Vue.prototype.isWexinLogin = false
}
Vue.config.productionTip = false
Vue.prototype.imgPath =
  'https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/yj_img/'
Vue.prototype.http = http
Vue.prototype.prohibitweixinShare = prohibitweixinShare //禁止微信右上角分享
Vue.prototype.shareExtensionFg = shareExtensionFg //分享关系
Vue.prototype.isIphoneX = isIphoneX() // 判断是否是iPhonex
// Vue.prototype.showOptionMenuFg = showOptionMenuFg  //显示微信右上角分享
Vue.use(CanvasPoster)
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // 记录列表滚动位置
  if (from.meta.keepAlive) {
    const $container = document.querySelector('.container')
    const scrollTop = $container ? $container.scrollTop : 0
    from.meta.scrollTop = scrollTop
  }
  next()
})
const preventReClick = Vue.directive('preventReClick', {
  inserted: function (el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 3000)
      }
      console.log(el.disabled)
    })
  }
});
Vue.prototype.preventReClick = preventReClick
new Vue({
  router,
  store,
  Vuex,
  render: h => h(App)
}).$mount('#app')
